import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
import { ServicesAccordion } from '../components/ServicesAccordion';
export function Contact() {
  const quickFAQs = [{
    question: 'How quickly can you attend?',
    answer: 'We typically schedule appointments within 24-48 hours. Same-day emergency callouts are available for urgent repairs.'
  }, {
    question: 'Do you charge for diagnostics?',
    answer: 'Yes, our diagnostic callout is £99. This covers the engineer visit, fault assessment, and transparent quote for any repairs needed.'
  }];
  return <div className="w-full bg-slate-50 py-16" data-id="element-264">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <div className="text-center mb-12" data-id="element-266">
          <h1 className="text-4xl font-bold text-slate-800 mb-4" data-id="element-267">Contact Us</h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-268">
            Your local appliance repair team — friendly, efficient and reliable
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12" data-id="element-269">
          <div className="bg-white rounded-xl shadow-md p-8" data-id="element-270">
            <h2 className="text-2xl font-bold text-slate-800 mb-6" data-id="element-271">
              Get in Touch
            </h2>
            <form className="space-y-6" data-id="element-272">
              <div data-id="element-273">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-274">
                  Name
                </label>
                <input type="text" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Your name" data-id="element-275" />
              </div>
              <div data-id="element-276">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-277">
                  Email
                </label>
                <input type="email" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="your.email@example.com" data-id="element-278" />
              </div>
              <div data-id="element-279">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-280">
                  Phone
                </label>
                <input type="tel" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Your phone number" data-id="element-281" />
              </div>
              <div data-id="element-282">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-283">
                  Postcode
                </label>
                <input type="text" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="e.g. PO2 0BQ" data-id="element-284" />
              </div>
              <div data-id="element-285">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-286">
                  Appliance Type
                </label>
                <select className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" data-id="element-287">
                  <option data-id="element-288">Select appliance</option>
                  <option data-id="element-289">Washing Machine</option>
                  <option data-id="element-290">Fridge/Freezer</option>
                  <option data-id="element-291">Cooker/Oven</option>
                  <option data-id="element-292">Dishwasher</option>
                  <option data-id="element-293">Tumble Dryer</option>
                </select>
              </div>
              <div data-id="element-294">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-295">
                  Fault Notes
                </label>
                <textarea rows={4} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Describe the issue with your appliance" data-id="element-296" />
              </div>
              <button type="submit" className="w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition" data-id="element-297">
                Send Message
              </button>
            </form>
          </div>
          <div data-id="element-298">
            <div className="bg-white rounded-xl shadow-md p-8 mb-6" data-id="element-299">
              <h2 className="text-2xl font-bold text-slate-800 mb-6" data-id="element-300">
                Contact Information
              </h2>
              <div className="space-y-6" data-id="element-301">
                <div className="flex items-start gap-4" data-id="element-302">
                  <MapPinIcon className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-303" />
                  <div data-id="element-304">
                    <h3 className="font-semibold text-slate-800 mb-1" data-id="element-305">
                      Address
                    </h3>
                    <p className="text-slate-600" data-id="element-306">
                      5 London Rd, Portsmouth PO2 0BQ
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-307">
                  <PhoneIcon className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-308" />
                  <div data-id="element-309">
                    <h3 className="font-semibold text-slate-800 mb-1" data-id="element-310">Phone</h3>
                    <a href="tel:08000554969" className="text-teal-600 hover:text-teal-700" data-id="element-311">
                      0800 055 4969
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-312">
                  <MailIcon className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-313" />
                  <div data-id="element-314">
                    <h3 className="font-semibold text-slate-800 mb-1" data-id="element-315">Email</h3>
                    <a href="mailto:Sumittandon092@gmail.com" className="text-teal-600 hover:text-teal-700 break-all" data-id="element-316">
                      Sumittandon092@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-317">
                  <ClockIcon className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-318" />
                  <div data-id="element-319">
                    <h3 className="font-semibold text-slate-800 mb-1" data-id="element-320">
                      Opening Hours
                    </h3>
                    <p className="text-slate-600" data-id="element-321">
                      Monday - Friday: 9:00 - 17:00
                    </p>
                    <p className="text-slate-600" data-id="element-322">Saturday - Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-md p-8 mb-6" data-id="element-323">
              <h3 className="text-xl font-bold text-slate-800 mb-4" data-id="element-324">
                Our Services
              </h3>
              <ServicesAccordion data-id="element-325" />
            </div>
            <div className="bg-teal-50 rounded-xl p-6 border border-teal-100" data-id="element-326">
              <h3 className="text-xl font-bold text-slate-800 mb-4" data-id="element-327">
                Quick Answers
              </h3>
              <div className="space-y-4" data-id="element-328">
                {quickFAQs.map((faq, index) => <div key={index} data-id="element-329">
                    <h4 className="font-semibold text-slate-800 mb-2" data-id="element-330">
                      {faq.question}
                    </h4>
                    <p className="text-sm text-slate-600" data-id="element-331">{faq.answer}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}